module.exports = __webpack_public_path__ + "static/media/r39.185020e1.jpg";